<template>
  <div class="projectData">
    <div class="title">
      <p>
        <span @click="goBack">资产管理</span>
        <span> / </span>
        <span @click="goBack">设备</span>
        <span> / </span>
        <span>数据详情</span>
      </p>
    </div>
    <div class="content">
      <div class="content">
        <div class="titleBox">
          <div>最后数据的时间: {{ lastTime }} &nbsp;
            <p style="display: inline-block;cursor: pointer" @click="getListFun">
              <el-icon style="transform: translateY(2px);color: #1890FF;">
                <RefreshRight/>
              </el-icon>&nbsp;
              <span style="color:#1890FF;">刷新</span>
            </p>
          </div>
          <div class="rightTitleBox">
            <div class="imgPox">
              <el-tooltip content="切换" placement="top">
                <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/toggle.png"
                     @click="showChartFlagClick">
              </el-tooltip>
              <el-tooltip content="分组分享" placement="top">
                <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/share.png"
                     @click="shareClick">
              </el-tooltip>
              <el-tooltip content="数据分类" placement="top">
                <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/catewayIcon.png"
                     @click="catewayClick">
              </el-tooltip>
              <!--              <el-tooltip content="导入分类" placement="top">-->
              <!--                <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/importIcon.png">-->
              <!--              </el-tooltip>-->
              <!--              <el-tooltip content="导出分类" placement="top">-->
              <!--                <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/exportIcon.png">-->
              <!--              </el-tooltip>-->
              <!--              <el-tooltip content="筛选数据项显示" placement="top">-->
              <!--                <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/filterIcon.png">-->
              <!--              </el-tooltip>-->
            </div>
            <p>产品型号：{{ productModel }}</p>
          </div>
        </div>
        <!--分类图表显示-->
        <div v-if="showChartFlag" class="contA">
          <div class="leftBox">
            <div class="leftTopBox">
              <div class="line">
                <span>日期： </span>
                <el-radio-group v-model="timeFlag2" @change="timeFlagSelect2">
                  <el-radio value="1H">1小时</el-radio>
                  <el-radio value="1D">日</el-radio>
                  <el-radio value="1W">周</el-radio>
                </el-radio-group>
                <div class="timeFlagSelectBox" style="width: 70px;">
                  <el-select v-model="timeFlag2" clearable @change="timeFlagSelect2">
                    <el-option label="自定义时间段" value="-1"></el-option>
                    <!--                    <el-option :disabled="chatType==4?false:true" label="瞬时" value="now"></el-option>-->
                    <el-option label="近1小时" value="1H"></el-option>
                    <el-option label="近12小时" value="12H"></el-option>
                    <el-option label="近一天" value="1D"></el-option>
                    <el-option label="近3天" value="3D"></el-option>
                    <el-option label="近1周" value="1W"></el-option>
                    <el-option label="本周" value="THIS_WEEK"></el-option>
                    <el-option label="本月" value="1M"></el-option>
                    <el-option label="本季" value="1Q"></el-option>
                  </el-select>
                  <p style="display:flex;align-items: center;position: absolute;left: 0;top: 2px;line-height: 29px"
                     @click.stop="">
                    <span>更多</span>
                    <!-- 自定义图标 -->
                    <el-icon style="margin-left: 5px;" @click="">
                      <RefreshRight/>
                    </el-icon>
                  </p>
                </div>
                <el-date-picker v-if="timeFlag2==='-1'" v-model="groupTime" end-placeholder="结束时间"
                                popper-class="date-style"
                                range-separator="→"
                                start-placeholder="开始时间"
                                style="margin-left: 15px" type="datetimerange"
                                value-format="YYYY-MM-DD HH:mm:ss"
                                @change="getGroupEchartsData">
                </el-date-picker>
              </div>
              <div style="margin-left: 15px;display: flex;align-items: center">
                <span style="display: inline-block">图表类型： </span>
                <el-select v-model="groupChatType" @change="getGroupEchartsData">
                  <el-option :value="1" label="折线图">折线图</el-option>
                  <el-option :value="0" label="柱状图">柱状图</el-option>
                </el-select>
              </div>
              <div class="line">
                <span>数据间隔： </span>
                <el-radio-group v-model="groupTimeUnit" @change="getGroupEchartsData">
                  <el-radio value="5m">5分钟</el-radio>
                  <el-radio value="15m">15分钟</el-radio>
                  <el-radio value="1d">日</el-radio>
                </el-radio-group>
                <div class="timeUnitSelectBox" style="width: 70px;">
                  <el-select v-model="groupTimeUnit" placeholder="请选择数据间隔" @change="getGroupEchartsData">
                    <el-option v-for="(item,index) in intervalList" :key="index" :label="item.value" :value="item.key"/>
                  </el-select>
                  <p style="display:flex;align-items: center;position: absolute;left: 0;top: 6px;line-height: 21px"
                     @click.stop="">
                    <span>更多</span>
                    <!-- 自定义图标 -->
                    <el-icon style="margin-left: 5px;" @click="">
                      <RefreshRight/>
                    </el-icon>
                  </p>
                </div>
              </div>
            </div>
            <div class="leftBottomBox">
              <p style="text-align: center;font-size: 18px;font-weight: 500;padding: 10px 0">
                {{
                  router.currentRoute.value.query.projectName + '-' + decodeURIComponent(router.currentRoute.value.query.equipmentName)
                }}</p>
              <div class="groupChart"></div>
            </div>
          </div>
          <div class="rightBox">
            <div class="rightTopBox">
              <div v-for="(item,index) in controlList" :key="index" class="btnBox">
                <el-button @click="productControlFun(item.key)">{{ item.value }}</el-button>
              </div>
            </div>
            <div class="rightBottomBox">
              <el-checkbox-group v-model="checkGroup" :min="1" @change="groupClick($event)">
                <el-checkbox v-for="(item,index) in shareGroupList" :key="index" :label="item.name" :value="item.id">
                  {{ item.name }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>

        <!--实时数据显示-->
        <div v-if="!showChartFlag" class="contB">
          <div v-show="controlList.length>0" class="controlList">
            <p>控制：</p>
            <div v-for="(item,index) in controlList" :key="index" class="btnBox">
              <el-button type="primary" @click="productControlFun(item.key)">{{ item.value }}</el-button>
            </div>
          </div>
          <!--数据详情-->
          <div class="echartsTabBox">
            <div v-for="(item,index) in monitoringList" :key="index" class="monitoringList">
              <p class="groupName">{{ item.name }}</p>
              <div v-for="(item_t,index_t) in item.list" :key="index_t" class="parentClass">
                <div class="echartsBox" style="position:relative;" @click="drawLineItem($event,index,index_t)">
                  <div class="leftDetail">
                    <!--{{String(item.title).replace(/\s/g,"&ensp;")}}-->

                    <el-tooltip :content="item_t.titleName" placement="top">
                      <div class="bigClass">{{ String(item_t.titleName).replace(/\s/g, "&ensp;") }}</div>
                    </el-tooltip>
                    <div class="signClass">
                      <span class="numberValueClass">{{ item_t.value }}</span>
                      <span style="margin-left: 5px;">{{ item_t.unitName }}</span>
                    </div>
                  </div>
                  <div class="rightDetail">
                    <div :id="forId(index)" :class="'echrtsClass'+'_'+index+'_'+index_t" class="echrtsClass"></div>
                  </div>
                  <div class="largeDetail" @click="dataSearch(item_t.id,item_t.dictKey)">
                    <!--                <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/%E6%89%A9%E5%A4%A7.svg"-->
                    <!--                     @click="dataSearch(item_t.id)"/>-->
                    查看详情
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog v-model="dialogVisible" title="数据查询" width="70%">
      <div class="searchHead">
        <div>
          <span>日期： </span>
          <el-select v-model="timeFlag" clearable style="width: 220px;margin-right: 15px"
                     @change="timeFlagSelect">
            <el-option label="自定义时间段" value="-1"></el-option>
            <el-option label="近1小时" value="1H"></el-option>
            <el-option label="近12小时" value="12H"></el-option>
            <el-option label="近一天" value="1D"></el-option>
            <el-option label="近3天" value="3D"></el-option>
            <el-option label="近1周" value="1W"></el-option>
            <el-option label="本周" value="THIS_WEEK"></el-option>
            <el-option label="本月" value="1M"></el-option>
            <el-option label="本季" value="1Q"></el-option>
          </el-select>
          <el-date-picker v-model="dateTime" end-placeholder="结束时间" popper-class="date-style" range-separator="→"
                          start-placeholder="开始时间" style="margin-right: 15px"
                          type="datetimerange" value-format="YYYY-MM-DD HH:mm:ss">
          </el-date-picker>
          <el-select v-if="timeFlag!='1H'" v-model="timeUnit" placeholder="请选择数据间隔" style="width: 220px">
            <el-option v-for="(item,index) in intervalList" :key="index" :label="item.value" :value="item.key"/>
          </el-select>
        </div>

        <el-button class="searchButton" style="text-align: right;" type="primary" @click="searchFun">查询</el-button>
      </div>
      <div v-show="echartsDataX.length>0" class="chart" style="height: 400px"></div>
      <el-empty v-if="echartsDataX.length===0"
                class="emptyClass" description="暂无数据信息"
                image="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/emptyImg.png"/>
      <template #footer>
				<span class="dialog-footer">
		    		<el-button class="resetButton" @click="dialogVisible = false">关闭</el-button>
      			</span>
      </template>
    </el-dialog>
    <!--显示弹窗-->
    <el-dialog v-model="showDialogVisible" :close-on-click-modal="false" class="showDialogVisible" title="数据分类"
               width="604px">
      <el-form-item label="分类名称" required>
        <el-select v-model="categoryId" :teleported="false" allow-create filterable @change="categoryNameSelect">
          <el-option v-for="(item,index) in categoryNameList" :key="index" :label="item.name"
                     :value="item.id">
            <span style="float: left">{{ item.name }}</span>
            <el-icon style="float: right;transform: translateY(10px);color: red;" @click.stop="delGroupClick(item.id)">
              <Delete/>
            </el-icon>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="差值" required>
        <el-radio-group v-model="diffFlag">
          <el-radio :value="1">差值</el-radio>
          <el-radio :value="0">读数</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="分类数据" required>
        <div class="transferBox">
          <el-transfer v-model="targetList" :data="showAllList" :titles="['未选中', '已选中']" filterable
                       target-order="push"/>
        </div>
      </el-form-item>

      <template #footer>
				<span class="dialog-footer">
		    		<el-button @click="showDialogVisible = false">取消</el-button>
		    		<el-button type="primary" @click="updateDataItemSaveFun()">保存</el-button>
      			</span>
      </template>
    </el-dialog>
    <!--分享弹窗-->
    <DeviceSelect4 :checkDeviceList="shareDeviceList" :deviceVisible="shareDialogVisible" :isMultiple="true"
                   @checkDeviceListFun="checkDeviceListFun" @deviceVisibleFun="deviceVisibleFun"/>
  </div>
</template>

<script setup>
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';
import {h, nextTick, onDeactivated, onMounted, onUnmounted, ref} from 'vue';
import './projectData.less'

import {useRouter} from "vue-router/dist/vue-router";
import DeviceSelect4 from '@/components/deviceSelect4'
import {ElLoading, ElMessage, ElMessageBox} from 'element-plus'
import {Delete, RefreshRight} from '@element-plus/icons-vue'
import {
  getDataItemCheckWithLocalEquipmentApi,
  getEquipmentDataGroupChartDataApi,
  getList,
  getListLocalDataMonitorPage,
  getListLocalLink,
  getLocalEquipmentGroupListApi,
  getShareGroupDeviceApi,
  getShareGroupListApi,
  saveLocalShareGroupApi,
  saveLocalWithEquipmentApi,
  saveShareGroupApi,
  saveWithEquipmentApi,
  saveWithEquipmentLinkApi
} from '@/api/modules/dataMonitoring'
import {
  exportDataApi,
  getDataListApi,
  getEchartsDataApi,
  getEquipmentListApi,
  getIntervalListApi,
  getSearchDetailApi,
  getSearchListApi,
  getTableDataApi
} from '@/api/modules/dataSearch'
import moment from 'moment'
import qs from 'qs';
import * as echarts from 'echarts';
import Sortable from "sortablejs";
import {
  delProductGroupListApi,
  getDataItemCheckWithEquipmentApi,
  getDataItemCheckWithLinkEquipmentApi,
  getEquipmentGroupListApi,
  getProductGroupListApi
} from "@/api/modules/productDetail";
import {productControl, productMqttControl, tProductControl} from "@/api/modules/deviceManagement";

let router = useRouter()


const goBack = function () {
  router.push({
    path: '/admin/project',
    query: {
      type: 1
    }
  })
}
// 加载的动画
let loadingAdd = ref()
const openFullScreen = function () {
  loadingAdd.value = ElLoading.service({
    lock: true,
    text: '',
    background: 'rgba(0, 0, 0, 0.1)'
  })
}

let productModel = ref()
let lastTime = ref()
let monitoringList = ref([])
let controlList = ref([])
//柱状图id(②数据监测)
const forId = function (index) {
  return 'geo_' + index;
}
const getListFun = function () {
  (router.currentRoute.value.query.isLocal == 2 && router.currentRoute.value.query.type == 3) ?
      getListLocalLink(qs.stringify({
        id: router.currentRoute.value.query.id
      })).then(res => {
        loadingAdd.value.close();
        //console.log(res);
        if (res.data.ok) {
          lastTime.value = res.data.result.lastTime
          productModel.value = res.data.result.productModel
          monitoringList.value = res.data.result.groupList
          controlList.value = res.data.result.controlList
          for (let i = 0; i < controlList.value.length; i++) {
            controlList.value[i].key = controlList.value[i].name
            controlList.value[i].value = controlList.value[i].id
          }
          for (let i = 0; i < monitoringList.value.length; i++) {
            monitoringList.value[i].list.sort((a, b) => a.dictKey.localeCompare(b.dictKey));
          }
        } else {
          ElMessage({
            message: res.data.message,
            type: 'error'
          })
        }
      }).catch(err => {
        console.log(err);
      }) : (router.currentRoute.value.query.isLocal == 2 ? getListLocalDataMonitorPage(qs.stringify({
        id: router.currentRoute.value.query.id
      })).then(res => {
        loadingAdd.value.close();
        //console.log(res);
        if (res.data.ok) {
          lastTime.value = res.data.result.lastTime
          productModel.value = res.data.result.productModel
          monitoringList.value = res.data.result.groupList
          controlList.value = res.data.result.controlList
          for (let i = 0; i < controlList.value.length; i++) {
            controlList.value[i].key = controlList.value[i].name
            controlList.value[i].value = controlList.value[i].id
          }
          for (let i = 0; i < monitoringList.value.length; i++) {
            monitoringList.value[i].list.sort((a, b) => a.dictKey.localeCompare(b.dictKey));
          }
        } else {
          ElMessage({
            message: res.data.message,
            type: 'error'
          })
        }
      }).catch(err => {
        console.log(err);
      }) : getList(qs.stringify({
        id: router.currentRoute.value.query.type == 4 ? router.currentRoute.value.query.equipmentId : router.currentRoute.value.query.id
      })).then(res => {
        loadingAdd.value.close();
        //console.log(res);
        if (res.data.ok) {
          lastTime.value = res.data.result.lastTime
          productModel.value = res.data.result.productModel
          monitoringList.value = res.data.result.groupList
          controlList.value = res.data.result.controlList
          for (let i = 0; i < controlList.value.length; i++) {
            controlList.value[i].value = controlList.value[i].name
            controlList.value[i].key = controlList.value[i].id
          }
          for (let i = 0; i < monitoringList.value.length; i++) {
            monitoringList.value[i].list.sort((a, b) => a.dictKey.localeCompare(b.dictKey));
          }
          // monitoringList.value = res.data.result.list
          // monitoringList.value.forEach(item => {
          //   item.valueList2 = []
          // })
          // monitoringList.value.forEach(item => {
          //   var arr = []
          //   if (item.valueList.length > 0) {
          //     item.valueList.forEach(items => {
          //       arr.push(item.maxValue * 0.02)
          //       item.valueList2 = arr
          //     })
          //   }
          // })
        } else {
          ElMessage({
            message: res.data.message,
            type: 'error'
          })
        }
      }).catch(err => {
        console.log(err);
      }))
  openFullScreen()
}
const drawLine = function (idx1, idx) {
  var echarts = require('echarts');
  if (idx !== undefined) {
    let myChart = echarts.init(document.querySelector(`.echrtsClass_${idx1}_${idx}`)); //
    myChart.clear(); //切换折线图前要先清除
    myChart.setOption({
      tooltip: {
        trigger: 'axis', // axis   item   none三个值
        show: true,
        /*formatter: function(params) {
    return(
     params[0].name +
     "<br/>" +
     "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:rgba(24,144,255)'></span>" +
     params[0].seriesName + "<span style='display:inline-block;margin-right:5px'></span>" + params[0].data);
   }*/
        formatter: function (params) {
          return (params[0].data);
        }
      },
      /*图表位置*/
      grid: {
        x: 0, //左留白
        y: 10, //上留白
        x2: 10, //右留白
        y2: 0 //下留白
      },
      title: {},
      legend: {
        data: [],
        //data: ['销量', 'xxm'],
      },
      //x轴
      xAxis: {
        data: monitoringList.value[idx1].list[idx].valueList,
        axisLine: {
          lineStyle: {
            color: '#ccc',
            width: 0 //x轴线
          }
        },
        //x轴线中的小竖的分割线
        axisTick: {
          show: false
        },
        show: false
      },
      //y轴
      yAxis: {
        axisLine: {
          lineStyle: {
            color: '#999',
          }
        },
        axisTick: {
          show: false
        },
        splitLine: {
          show: false
        }
      },
      series: [{
        name: monitoringList.value[idx1].list[idx].titleName,
        type: 'line',
        // barGap: '-100%',
        stack: 'xxm',
        data: monitoringList.value[idx1].list[idx].valueList,
        color: '#457DFC',
      }]
    });
    myChart.resize();
    window.onresize = () => {
      myChart.resize();
    }
  } else {
    var roseCharts = document.querySelectorAll('.echrtsClass');
    for (var i = 0; i < roseCharts.length; i++) {
      let myChart = echarts.init(roseCharts[i]); //
      myChart.clear(); //切换折线图前要先清除
      myChart.setOption({
        tooltip: {
          trigger: 'axis', // axis   item   none三个值
          show: true,
          /*formatter: function(params) {
      return(
       params[0].name +
       "<br/>" +
       "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:rgba(24,144,255)'></span>" +
       params[0].seriesName + "<span style='display:inline-block;margin-right:5px'></span>" + params[0].data);
     }*/
          formatter: function (params) {
            return (params[0].data);
          }
        },
        /*图表位置*/
        grid: {
          x: 0, //左留白
          y: 10, //上留白
          x2: 10, //右留白
          y2: 0 //下留白
        },
        title: {},
        legend: {
          data: [],
          //data: ['销量', 'xxm'],
        },
        //x轴
        xAxis: {
          // data: ["10-01", "10-02", "10-03", "10-04", "10-05", "10-06", "10-01", "10-02", "10-03", "10-04", "10-05", "10-06",],
          data: monitoringList.value[i].valueList,
          axisLine: {
            lineStyle: {
              color: '#ccc',
              width: 0 //x轴线
            }
          },
          //x轴线中的小竖的分割线
          axisTick: {
            show: false
          },
          show: false
        },
        //y轴
        yAxis: {
          axisLine: {
            lineStyle: {
              color: '#999',
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        series: [{
          name: monitoringList.value[i].titleName,
          type: 'line',
          // barGap: '-100%',
          stack: 'xxm',
          data: monitoringList.value[i].valueList,
          color: '#457DFC',
        }]
      });

      myChart.resize();
      window.onresize = () => {
        myChart.resize();
      }
    }
  }

}
const drawLineItem = function (e, idx1, idx) {
  nextTick(() => {
    for (let i = 0; i < document.querySelectorAll('.monitoringList').length; i++) {
      for (let j = 0; j < document.querySelectorAll('.monitoringList')[i].querySelectorAll('.parentClass').length; j++) {
        document.querySelectorAll('.monitoringList')[i].querySelectorAll('.parentClass')[j].querySelector('.rightDetail').style.display = 'none'
        document.querySelectorAll('.monitoringList')[i].querySelectorAll('.parentClass')[j].querySelector('.largeDetail').style.display = 'none'
      }
    }
    document.querySelectorAll('.monitoringList')[idx1].querySelectorAll('.parentClass')[idx].querySelector('.rightDetail').style.display = 'block'
    document.querySelectorAll('.monitoringList')[idx1].querySelectorAll('.parentClass')[idx].querySelector('.largeDetail').style.display = 'block'
    drawLine(idx1, idx)
  })
}
// const intervalId = setInterval(getListFun, 5000)

onUnmounted(() => {
  // clearInterval(intervalId)
})
onDeactivated(() => {
  // clearInterval(intervalId)
})
/*数据查询*/
let dialogVisible = ref(false)
const dataSearch = function (id, key) {
  equipmentArr.value[0].dictIds = []
  equipmentArr.value[0].dictKeys = []
  dialogVisible.value = true
  equipmentArr.value[0].dictIds.push(id)
  equipmentArr.value[0].dictKeys.push(key)
  plan.value = null
  timeFlag.value = '1H'
  dateTime.value = [moment().subtract(1, "hours").format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]
  frequency.value = 1
  timeUnit.value = ''
  yom.value = []
  echartsData.value = []
  echartsDataX.value = []
  tableData.value = []
  getTableDataFun()
}
// 搜索
let plan = ref() //选择的搜索方案
let timeFlag = ref('1H') //日期快捷选择
let dateTime = ref([moment().subtract(1, "hours").format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]) //搜索日期
let frequency = ref(1) //频率
let timeUnit = ref('') //频率单位
let yom = ref([]) //同环比
let equipmentArr = ref([{
  deviceId: router.currentRoute.value.query.id,
  dictIds: [],
  dictKeys: [],
}]) //搜索的设备
// 日期快捷选择事件
const timeFlagSelect = function () {
  if (timeFlag.value === '-1') {
    dateTime.value = []
  } else if (timeFlag.value === '1H') {
    dateTime.value = [moment().subtract(1, "hours").format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]
    frequency.value = 1
    timeUnit.value = '1m'
  } else if (timeFlag.value === '12H') {
    dateTime.value = [moment().subtract(12, "hours").format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]
    frequency.value = 5
    timeUnit.value = '1m'
  } else if (timeFlag.value === '1D') {
    dateTime.value = [moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]
    frequency.value = 10
    timeUnit.value = '1m'
  } else if (timeFlag.value === '3D') {
    dateTime.value = [moment().subtract(2, "days").startOf('day').format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]
    frequency.value = 30
    timeUnit.value = '1m'
  } else if (timeFlag.value === '1W') {
    dateTime.value = [moment().subtract(6, "days").startOf('day').format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]
    frequency.value = 1
    timeUnit.value = '1h'
  } else if (timeFlag.value === 'THIS_WEEK') {
    dateTime.value = [moment().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')]
    frequency.value = 1
    timeUnit.value = '1h'
  } else if (timeFlag.value === '1M') {
    dateTime.value = [moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment().format('YYYY-MM-DD HH:mm:ss')]
    frequency.value = 2
    timeUnit.value = '1h'
  } else if (timeFlag.value === '1Q') {
    dateTime.value = [moment().quarter(moment(moment(), "YYYY-MM-DD").quarter()).startOf('quarter').format("YYYY-MM-DD HH:mm:ss"), moment().format('YYYY-MM-DD HH:mm:ss')]
    frequency.value = 6
    timeUnit.value = '1h'
  }
}

// 设备列表
let equipmentList = ref([])
// 指标列表
let dataList = ref([])
// 获取设备列表
const getEquipmentListFun = async function () {
  await getEquipmentListApi().then(res => {
    if (res.data.code === 200) {
      equipmentList.value = res.data.data
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message
      })
    }
  }).catch(err => {
    console.log(err);
  })
}
// 获取指标列表
const getDataListFun = async function (index, id) {
  if (id) {
    await getDataListApi(id).then(res => {
      if (res.data.code === 200) {
        dataList.value[index] = res.data.data
      } else {
        ElMessage({
          type: 'error',
          message: res.data.message
        })
      }
    }).catch(err => {
      console.log(err);
    })
  }
}

// 点击删除设备
const delClick = function (index) {
  equipmentArr.value.splice(index, 1)
  dataList.value.splice(index, 1)
}

// 获取图表数据
let titleName = ref()
let echartsData = ref([])
let echartsDataX = ref([])
const getEchartsDataFun = async function () {
  echartsDataX.value = []
  echartsData.value = []
  let data = {
    startTime: dateTime.value ? dateTime.value[0] : '',
    endTime: dateTime.value ? dateTime.value[1] : '',
    frequency: frequency.value,
    timeUnit: timeUnit.value,
    params: equipmentArr.value,
    yom: yom.value[0]
  }
  // 计算同环比时间
  if (yom.value && yom.value[0] == 1) {
    data.lastStartTime = moment(data.startTime).subtract(1, 'years').format("YYYY-MM-DD HH:mm:ss")
    data.lastEndTime = moment(data.endTime).subtract(1, 'years').format("YYYY-MM-DD HH:mm:ss")
  } else if (yom.value && yom.value[0] == 2) {
    if (timeFlag.value === '1M') {
      data.lastStartTime = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD HH:mm:ss')
      data.lastEndTime = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD HH:mm:ss')
    } else if (timeFlag.value === '1Q') {
      data.lastStartTime = moment().quarter(moment(moment(), "YYYY-MM-DD").quarter()).subtract(1, 'quarter').startOf('quarter').format("YYYY-MM-DD HH:mm:ss")
      data.lastEndTime = moment().quarter(moment(moment(), "YYYY-MM-DD").quarter()).subtract(1, 'quarter').endOf('quarter').format("YYYY-MM-DD HH:mm:ss")
    } else {
      let timeLength = moment(data.endTime).diff(data.startTime, 'second')
      data.lastStartTime = moment(data.startTime).subtract(timeLength, 'second').format('YYYY-MM-DD HH:mm:ss')
      data.lastEndTime = moment(data.endTime).subtract(timeLength, 'second').format('YYYY-MM-DD HH:mm:ss')
    }
  }
  let flag = false
  for (let i = 0; i < data.params.length; i++) {
    if (!data.params[i].deviceId || data.params[i].dictKeys) {
      flag = true
    }
    delete data.params[i].dictIds
  }
  if (data.frequency && data.timeUnit) {
    openFullScreen()
    await getEchartsDataApi(data).then(res => {
      loadingAdd.value.close()
      if (res.data.code === 0) {
        echartsDataX.value = res.data.result.xAxis
        echartsData.value = res.data.result.yAxis
        for (let i = 0; i < echartsData.value.length; i++) {
          echartsData.value[i].name = echartsData.value[i].deviceName + '-' + echartsData.value[i].titleName
          echartsData.value[i].type = 'line'
          echartsData.value[i].lineStyle = {
            width: 1
          }
          echartsData.value[i].symbol = 'circle'
          // echartsData.value[i].symbol = 'none'
          echartsData.value[i].sampling = 'lttb'
          for (let j = 0; j < echartsData.value[i].data.length; j++) {
            echartsData.value[i].data[j] = Number(echartsData.value[i].data[j]).toFixed(2)
          }
        }
        nextTick(() => {
          chartLoad()
        })
      } else {
        ElMessage({
          type: 'error',
          message: res.data.message
        })
      }
    }).catch(err => {
      console.log(err);
    })
  } else {
    ElMessage({
      type: 'info',
      message: '请选择筛选条件'
    })
  }
}
// 获取表格数据
let tableData = ref([])
let pageData = ref([])
const getTableDataFun = async function () {
  pageData.value = []
  tableData.value = []
  for (let i = 0; i < equipmentArr.value.length; i++) {
    pageData.value.push({
      pageNum: 1,
      pageSize: 10
    })
    let data = {
      startTime: dateTime.value ? dateTime.value[0] : '',
      endTime: dateTime.value ? dateTime.value[1] : '',
      pageNum: pageData.value[i].pageNum,
      pageSize: 1000,
      frequency: frequency.value,
      timeUnit: timeUnit.value,
      params: [equipmentArr.value[i]]
    }
    // 计算同环比时间
    if (yom.value && yom.value[0] == 1) {
      data.lastStartTime = moment(data.startTime).subtract(1, 'years').format("YYYY-MM-DD HH:mm:ss")
      data.lastEndTime = moment(data.endTime).subtract(1, 'years').format("YYYY-MM-DD HH:mm:ss")
      console.log(data.lastStartTime, data.lastEndTime)
    } else if (yom.value && yom.value[0] == 2) {
      if (timeFlag.value === '1M') {
        let lastStartTime = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD HH:mm:ss')
        let lastEndTime = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD HH:mm:ss')
      } else if (timeFlag.value === '1Q') {
        data.lastStartTime = moment().quarter(moment(moment(), "YYYY-MM-DD").quarter()).subtract(1, 'quarter').startOf('quarter').format("YYYY-MM-DD HH:mm:ss")
        data.lastEndTime = moment().quarter(moment(moment(), "YYYY-MM-DD").quarter()).subtract(1, 'quarter').endOf('quarter').format("YYYY-MM-DD HH:mm:ss")
      } else {
        let timeLength = moment(data.endTime).diff(data.startTime, 'second')
        data.lastStartTime = moment(data.startTime).subtract(timeLength, 'second').format('YYYY-MM-DD HH:mm:ss')
        data.lastEndTime = moment(data.endTime).subtract(timeLength, 'second').format('YYYY-MM-DD HH:mm:ss')
      }
    }
    let flag = false
    for (let i = 0; i < data.params.length; i++) {
      if (!data.params[i].deviceId || (data.params[i].dictIds.length === 0)) {
        flag = true
      }
    }
    if (data.frequency) {
      openFullScreen()
      await getTableDataApi(data).then(res => {
        loadingAdd.value.close()
        if (res.data.code === 0) {
          echartsDataX.value = []
          echartsData.value = [{
            data: []
          }]
          if (res.data.result.list.length > 0) {
            var arr = res.data.result.list[0].dataMetricsVO.reverse()
            for (var i = 0; i < arr.length; i++) {
              echartsDataX.value.push(arr[i].ts)
              echartsData.value[0].data.push(arr[i].metricDataList[0].val)
            }
            for (let i = 0; i < echartsData.value.length; i++) {
              echartsData.value[i].name = arr[i].metricDataList[0].titleName
              echartsData.value[i].type = 'line'
              echartsData.value[i].lineStyle = {
                width: 1
              }
              echartsData.value[i].symbol = 'circle'
              echartsData.value[i].sampling = 'lttb'
              for (let j = 0; j < echartsData.value[i].data.length; j++) {
                echartsData.value[i].data[j] = Number(echartsData.value[i].data[j]).toFixed(2)
              }
            }
          }
          nextTick(() => {
            chartLoad()
          })
        } else {
          ElMessage({
            type: 'error',
            message: res.data.message
          })
        }
      }).catch(err => {
        console.log(err);
      })
    } else {
      ElMessage({
        type: 'info',
        message: '请选择筛选条件'
      })
    }
  }
}

// 查询
const searchFun = async function () {
  if (timeFlag.value == '1H') {
    getTableDataFun()
  } else {
    getEchartsDataFun()
  }
}
// 重置
const resetFun = function () {
  plan.value = ''
  dateTime.value = ''
  frequency.value = 1
  timeUnit.value = ''
  timeFlag.value = ''
  yom.value = []
  equipmentArr.value = [{
    deviceId: '',
    dictIds: [],
    dictKeys: [],
  }]

  echartsData.value = []
  echartsDataX.value = []
  tableData.value = []
  nextTick(() => {
    chartLoad()
  })
}

// 控制展示图表还是表格
let showFlag = ref(true)
const showClick = async function (flag) {
  // showFlag.value = flag === 1;
  if (flag === 1) {
    showFlag.value = true
    await getEchartsDataFun()
    if (tableData.value.length > 0) {
      await nextTick(() => {
        chartLoad()
      })
    }
  } else {
    await getTableDataFun()
    showFlag.value = false
  }
}

// 加载图表
const chartLoad = function () {
  var chartDom = document.querySelector('.chart');
  var myChart = echarts.init(chartDom);
  var option;

  option = {
    // toolbox: {
    //   feature: {
    //     dataZoom: {
    //       yAxisIndex: 'none'
    //     },
    //     restore: {},
    //     saveAsImage: {}
    //   }
    // },
    grid: {
      left: 50,
      right: 20
    },
    legend: {
      show: true,
      type: 'scroll'
    },
    tooltip: {
      trigger: 'axis', // axis   item   none三个值
      show: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: echartsDataX.value
    },
    yAxis: {
      type: 'value',
    },
    dataZoom: [{
      type: 'inside',
      start: 0,
      end: 100,
      disabled: false
    },
      {
        start: 0,
        end: 100
      }
    ],
    series: echartsData.value
  };
  myChart.clear()
  option && myChart.setOption(option);

  myChart.resize();
  window.onresize = () => {
    myChart.resize();
  }
}

// 点击导出
const exportFun = function () {
  let data = {
    startTime: dateTime.value ? dateTime.value[0] : '',
    endTime: dateTime.value ? dateTime.value[1] : '',
    frequency: frequency.value,
    timeUnit: timeUnit.value,
    params: equipmentArr.value,
    yom: yom.value[0]
  }
  // 计算同环比时间
  if (yom.value && yom.value[0] == 1) {
    data.lastStartTime = moment(data.startTime).subtract(1, 'years').format("YYYY-MM-DD HH:mm:ss")
    data.lastEndTime = moment(data.endTime).subtract(1, 'years').format("YYYY-MM-DD HH:mm:ss")
  } else if (yom.value && yom.value[0] == 2) {
    if (timeFlag.value === '1M') {
      data.lastStartTime = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD HH:mm:ss')
      data.lastEndTime = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD HH:mm:ss')
    } else if (timeFlag.value === '1Q') {
      data.lastStartTime = moment().quarter(moment(moment(), "YYYY-MM-DD").quarter()).subtract(1, 'quarter').startOf('quarter').format("YYYY-MM-DD HH:mm:ss")
      data.lastEndTime = moment().quarter(moment(moment(), "YYYY-MM-DD").quarter()).subtract(1, 'quarter').endOf('quarter').format("YYYY-MM-DD HH:mm:ss")
    } else {
      let timeLength = moment(data.endTime).diff(data.startTime, 'second')
      data.lastStartTime = moment(data.startTime).subtract(timeLength, 'second').format('YYYY-MM-DD HH:mm:ss')
      data.lastEndTime = moment(data.endTime).subtract(timeLength, 'second').format('YYYY-MM-DD HH:mm:ss')
    }
  }
  let flag = false
  for (let i = 0; i < data.params.length; i++) {
    if (!data.params[i].deviceId || (data.params[i].dictIds.length === 0)) {
      flag = true
    }
  }

  if (data.frequency && data.timeUnit && !flag) {
    const downloadZip = (data, fileName = '数据查询') => {
      var blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
      if ('download' in document.createElement('a')) {
        var downloadElement = document.createElement('a')
        var href = window.URL.createObjectURL(blob) //创建下载的链接
        downloadElement.href = href
        downloadElement.download = fileName //下载后文件名
        document.body.appendChild(downloadElement)
        downloadElement.click() //点击下载
        document.body.removeChild(downloadElement) //下载完成移除元素
        window.URL.revokeObjectURL(href) //释放掉blob对象
      }
    }
    openFullScreen()
    exportDataApi(data).then(res => {
      loadingAdd.value.close()
      downloadZip(res.data)
    }).catch(err => {
      console.log(err);
    })
  } else {
    ElMessage({
      type: 'info',
      message: '请选择筛选条件'
    })
  }
}

// 获取查询方案列表
let planList = ref([])
const getSearchListFun = async function () {
  await getSearchListApi({type: 0}).then(res => {
    if (res.data.code === 200) {
      planList.value = res.data.data
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message
      })
    }
  }).catch(err => {
    console.log(err);
  })
}
// 查询方案change事件
const planChange = async function () {
  await getSearchDetailApi(plan.value).then(res => {
    if (res.data.code === 200) {
      frequency.value = res.data.data.frequency
      timeUnit.value = res.data.data.timeUnit
      timeFlag.value = res.data.data.timeFlag
      yom.value = res.data.data.yom ? [res.data.data.yom] : []
      timeFlagSelect()
      if (timeFlag.value === '-1') {
        dateTime.value = [res.data.data.startTime, res.data.data.endTime]
      }
      equipmentArr.value = res.data.data.deviceConditionList
      for (let i = 0; i < res.data.data.deviceConditionList.length; i++) {
        getDataListFun(i, res.data.data.deviceConditionList[i].deviceId)
      }
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message
      })
    }
  }).catch(err => {
    console.log(err);
  })
}


// 分组操作------------------------------------------------------------
// 显示分组
let categoryId = ref()
let diffFlag = ref()
let categoryName = ref()
let categoryNameList = ref([])
const categoryNameSelect = function (e) {
  let flag = false
  for (let i = 0; i < categoryNameList.value.length; i++) {
    if (categoryNameList.value[i].id == e) {
      flag = true
      categoryName.value = categoryNameList.value[i].name
    }
  }
  if (flag) {
    getDataItemCheckWithEquipmentFun(e)
  } else {
    getDataItemCheckWithEquipmentFun(0)
  }

}
//显示分组保存
const updateDataItemSaveFun = function () {
  let dictIdList = targetList.value.toString()
  let groupId = 0
  for (let i = 0; i < categoryNameList.value.length; i++) {
    if (categoryNameList.value[i].id == categoryId.value) {
      groupId = categoryId.value
    }
  }

  (router.currentRoute.value.query.isLocal == 2 && router.currentRoute.value.query.type == 3) ?
      saveWithEquipmentLinkApi(qs.stringify({
        id: groupId,
        equipmentId: router.currentRoute.value.query.id,
        name: groupId !== 0 ? categoryName.value : categoryId.value,
        diffFlag: diffFlag.value,
        dictIdList: dictIdList
      })).then(res => {
        //console.log(res);
        if (res.data.ok) {
          showDialogVisible.value = false
          getListFun()
          if (showChartFlag.value) {
            getShareGroupListFun()
          }
        } else {
          ElMessage({
            message: res.data.message,
            type: 'error'
          })
        }
      }).catch(err => {
        console.log(err);
      }) : (router.currentRoute.value.query.isLocal == 2 ? saveLocalWithEquipmentApi(qs.stringify({
        id: groupId,
        equipmentId: router.currentRoute.value.query.type == 4 ? router.currentRoute.value.query.equipmentId : router.currentRoute.value.query.id,
        name: groupId !== 0 ? categoryName.value : categoryId.value,
        diffFlag: diffFlag.value,
        dictIdList: dictIdList
      })).then(res => {
        //console.log(res);
        if (res.data.ok) {
          showDialogVisible.value = false
          getListFun()
          if (showChartFlag.value) {
            getShareGroupListFun()
          }
        } else {
          ElMessage({
            message: res.data.message,
            type: 'error'
          })
        }
      }).catch(err => {
        console.log(err);
      }) : saveWithEquipmentApi(qs.stringify({
        id: groupId,
        equipmentId: router.currentRoute.value.query.type == 4 ? router.currentRoute.value.query.equipmentId : router.currentRoute.value.query.id,
        name: groupId !== 0 ? categoryName.value : categoryId.value,
        diffFlag: diffFlag.value,
        dictIdList: dictIdList
      })).then(res => {
        //console.log(res);
        if (res.data.ok) {
          showDialogVisible.value = false
          getListFun()
          if (showChartFlag.value) {
            getShareGroupListFun()
          }
        } else {
          ElMessage({
            message: res.data.message,
            type: 'error'
          })
        }
      }).catch(err => {
        console.log(err);
      }))

}
let showAllList = ref([]) //所有显示列表
let showDialogVisible = ref(false)
// 获取显示穿梭框的数据
const getDataItemCheckWithEquipmentFun = function (id) {
  (router.currentRoute.value.query.isLocal == 2 && router.currentRoute.value.query.type == 3) ?
      getDataItemCheckWithLinkEquipmentApi(qs.stringify({
        equipmentId: router.currentRoute.value.query.id,
        id: id
      })).then(res => {
        if (res.data.code === 0) {
          res.data.result.list.forEach(item => {
            item.key = item.id
            item.label = item.name
            if (item.checkFlag == 1) {
              item.checked = true
            } else {
              item.checked = false
            }
          })
          res.data.result.checkList.forEach(item => {
            item.key = item.id
            item.label = item.name
            if (item.checkFlag == 1) {
              item.checked = true
            } else {
              item.checked = false
            }
          })
          // 处理穿梭框未选中数据
          showAllList.value = res.data.result.list
          // 处理穿梭框选中的数据
          var arr = []
          res.data.result.checkList.forEach(item => {
            arr.push(item.id)
          })
          targetList.value = arr
          diffFlag.value = res.data.result.diffFlag
        } else {
          ElMessage({
            message: res.data.message,
            type: 'error'
          })
        }
      }).catch(err => {
        console.log(err);
      }) : (router.currentRoute.value.query.isLocal == 2 ? getDataItemCheckWithLocalEquipmentApi(qs.stringify({
        equipmentId: router.currentRoute.value.query.type == 4 ? router.currentRoute.value.query.equipmentId : router.currentRoute.value.query.id,
        id: id
      })).then(res => {
        if (res.data.code === 0) {
          res.data.result.list.forEach(item => {
            // item.key = item.id
            item.label = item.name
            if (item.checkFlag == 1) {
              item.checked = true
            } else {
              item.checked = false
            }
          })
          res.data.result.checkList.forEach(item => {
            // item.key = item.id
            item.label = item.name
            if (item.checkFlag == 1) {
              item.checked = true
            } else {
              item.checked = false
            }
          })
          // 处理穿梭框未选中数据
          showAllList.value = res.data.result.list
          // 处理穿梭框选中的数据
          var arr = []
          res.data.result.checkList.forEach(item => {
            arr.push(item.key)
          })
          targetList.value = arr
          diffFlag.value = res.data.result.diffFlag
        } else {
          ElMessage({
            message: res.data.message,
            type: 'error'
          })
        }
      }).catch(err => {
        console.log(err);
      }) : getDataItemCheckWithEquipmentApi(qs.stringify({
        equipmentId: router.currentRoute.value.query.type == 4 ? router.currentRoute.value.query.equipmentId : router.currentRoute.value.query.id,
        id: id
      })).then(res => {
        if (res.data.code === 0) {
          res.data.result.list.forEach(item => {
            item.key = item.id
            item.label = item.name
            if (item.checkFlag == 1) {
              item.checked = true
            } else {
              item.checked = false
            }
          })
          res.data.result.checkList.forEach(item => {
            item.key = item.id
            item.label = item.name
            if (item.checkFlag == 1) {
              item.checked = true
            } else {
              item.checked = false
            }
          })
          // 处理穿梭框未选中数据
          showAllList.value = res.data.result.list
          // 处理穿梭框选中的数据
          var arr = []
          res.data.result.checkList.forEach(item => {
            arr.push(item.id)
          })
          targetList.value = arr
          diffFlag.value = res.data.result.diffFlag
        } else {
          ElMessage({
            message: res.data.message,
            type: 'error'
          })
        }
      }).catch(err => {
        console.log(err);
      }))
}
// 获取分组的下拉列表
const getProductGroupListFun = function () {
  (router.currentRoute.value.query.isLocal == 2 && router.currentRoute.value.query.type == 3) ?
      getProductGroupListApi(qs.stringify({
        mainId: router.currentRoute.value.query.id,
        type: 3
      })).then(res => {
        if (res.data.code === 0) {
          categoryNameList.value = res.data.result
        } else {
          ElMessage({
            message: res.data.message,
            type: 'error'
          })
        }
      }).catch(err => {
        console.log(err);
      }) : (router.currentRoute.value.query.isLocal == 2 ? getLocalEquipmentGroupListApi(qs.stringify({
        equipmentId: router.currentRoute.value.query.type == 4 ? router.currentRoute.value.query.equipmentId : router.currentRoute.value.query.id
      })).then(res => {
        if (res.data.code === 0) {
          categoryNameList.value = res.data.result
        } else {
          ElMessage({
            message: res.data.message,
            type: 'error'
          })
        }
      }).catch(err => {
        console.log(err);
      }) : getEquipmentGroupListApi(qs.stringify({
        equipmentId: router.currentRoute.value.query.type == 4 ? router.currentRoute.value.query.equipmentId : router.currentRoute.value.query.id
      })).then(res => {
        if (res.data.code === 0) {
          categoryNameList.value = res.data.result
        } else {
          ElMessage({
            message: res.data.message,
            type: 'error'
          })
        }
      }).catch(err => {
        console.log(err);
      }))

}
const catewayClick = function () {
  categoryId.value = ''
  showDialogVisible.value = true
  nextTick(() => {
    var el = document.querySelectorAll('.el-checkbox-group')[1];
    var sortable = Sortable.create(el, {
      onEnd: function (evt) {
        const movedItem = targetList.value.splice(evt.oldIndex, 1)[0];
        targetList.value.splice(evt.newIndex, 0, movedItem);
      }
    });
  })
  // 获取分组的下拉列表
  // 获取显示穿梭框的数据
  getDataItemCheckWithEquipmentFun(0)
  getProductGroupListFun()
}
const generateData = () => {
  const data = []
  for (let i = 1; i <= 15; i++) {
    data.push({
      key: i,
      label: `Option ${i}`,
    })
  }
  return data
}
const data = ref(generateData())
const targetList = ref([])
// 删除显示分组
const delGroupClick = function (id) {
  ElMessageBox.confirm("确认删除吗，删除后不可恢复，请谨慎操作", '', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    title: '删除分组',
    message: h('p', null, [
      h('img', {
        src: 'https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/info.png',
        style: 'width:20px;height:20px;transform: translateY(4px);margin-right:8px;'
      }, ''),
      h('span', {
        style: 'color:#595959;'
      }, '请确认是否要删除此分组，删除后数据不可恢复'),
    ])
  }).then(() => {
    delProductGroupListApi(qs.stringify({id: id})).then(res => {
      if (res.data.ok) {
        getProductGroupListFun()
      } else {
        ElMessage({
          message: res.data.message,
          type: 'error'
        })
      }
    }).catch(err => {
      console.log(err);
    })
  }).catch(() => {
    ElMessage({
      message: '已取消删除',
      type: 'info',
    })
  });
}


//控制的点击------------------------------------------------------------
const productControlFun = function (controlId) {
  router.currentRoute.value.query.type == 4 ? productMqttControl(qs.stringify({
    id: router.currentRoute.value.query.id,
    type: controlId
  })).then(res => {
    if (res.data.ok) {
      ElMessage({
        type: 'success',
        message: '设置控制操作成功！'
      });
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message + '!'
      });
    }
  }).catch(err => {
    console.log(err)
  }) : productControl(qs.stringify({
    equipmentId: router.currentRoute.value.query.id,
    controlId: controlId
  })).then(res => {
    if (res.data.ok) {
      ElMessage({
        type: 'success',
        message: '设置控制操作成功！'
      });
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message + '!'
      });
    }
  }).catch(err => {
    console.log(err)
  })
}
//控制的点击2
const productControlFun2 = function (num) {
  openFullScreen()
  tProductControl({
    onOrOff: num !== 1,
    deviceId: router.currentRoute.value.query.id
  }).then(res => {
    loadingVal.value.close()
    if (res.data.ok) {
      ElMessage({
        type: 'success',
        message: '设置控制操作成功！'
      });
    } else {
      loadingVal.value.close()
      ElMessage({
        type: 'error',
        message: res.data.message + '!'
      });
    }
  }).catch(err => {
    console.log(err)
  })
}


// 切换展示方式
const showChartFlagClick = function () {
  showChartFlag.value = !showChartFlag.value
  getListFun()
  if (showChartFlag.value) {
    getShareGroupListFun()
  }
}


// 分组图表------------------------------------------------------------
let showChartFlag = ref(true)  //默认展示分组图表
let checkGroup = ref([])  //选择的图表
// 选择分组
const groupClick = function (val) {
  if (val.length > 0) {
    checkGroup.value = [val[val.length - 1]]
    getGroupEchartsData()
  }

}
// 获取分组列表
let shareGroupList = ref([])
const getShareGroupListFun = function () {
  router.currentRoute.value.query.isLocal == 2 ? getLocalEquipmentGroupListApi(qs.stringify({
    equipmentId: router.currentRoute.value.query.type == 4 ? router.currentRoute.value.query.equipmentId : router.currentRoute.value.query.id
  })).then(async res => {
    if (res.data.code === 0) {
      shareGroupList.value = res.data.result
      checkGroup.value = [shareGroupList.value[0].id]
      getGroupEchartsData()
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message,
      })
    }
  }).catch(err => {
    console.log(err);
  }) : getShareGroupListApi(qs.stringify({
    equipmentId: router.currentRoute.value.query.type == 4 ? router.currentRoute.value.query.equipmentId : router.currentRoute.value.query.id
  })).then(async res => {
    if (res.data.code === 0) {
      shareGroupList.value = res.data.result
      checkGroup.value = [res.data.result[0].id]
      getGroupEchartsData()
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message,
      })
    }
  }).catch(err => {
    console.log(err);
  })
}


// 筛选条件
let groupTime = ref([moment().subtract(6, "days").startOf('day').format("YYYY-MM-DD HH:mm:ss"), moment().format('YYYY-MM-DD HH:mm:ss')])  //时间
let groupTimeUnit = ref('1d')  //时间间隔
let groupChatType = ref(1)  //图表类型
let timeFlag2 = ref('1W')
// 日期快捷选择事件
const timeFlagSelect2 = function () {
  if (timeFlag2.value === '-1') {
    groupTime.value = []
  } else if (timeFlag2.value === '1H') {
    groupTime.value = [moment().subtract(1, "hours").format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]
  } else if (timeFlag2.value === '12H') {
    groupTime.value = [moment().subtract(12, "hours").format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]
  } else if (timeFlag2.value === '1D') {
    groupTime.value = [moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]
  } else if (timeFlag2.value === '3D') {
    groupTime.value = [moment().subtract(2, "days").startOf('day').format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]
  } else if (timeFlag2.value === '1W') {
    groupTime.value = [moment().subtract(6, "days").startOf('day').format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]
  } else if (timeFlag2.value === 'THIS_WEEK') {
    groupTime.value = [moment().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'), moment().format("YYYY-MM-DD HH:mm:ss")]
  } else if (timeFlag2.value === '1M') {
    groupTime.value = [moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment().format("YYYY-MM-DD HH:mm:ss")]
  } else if (timeFlag2.value === '1Q') {
    groupTime.value = [moment().quarter(moment(moment(), "YYYY-MM-DD").quarter()).startOf('quarter').format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]
    // dateTime.value = [moment().quarter(moment(moment(), "YYYY-MM-DD").quarter()).startOf('quarter').format("YYYY-MM-DD HH:mm:ss"), moment().quarter(moment(moment(), "YYYY-MM-DD").quarter()).endOf('quarter').format("YYYY-MM-DD HH:mm:ss")]
  }
  console.log(groupTime.value)
  getGroupEchartsData()
}


// 分组图表加载
let colorArr = ['rgba(69,125,252,1)', 'rgba(189,82,244,1)', 'rgba(0,229,166,1)', 'rgba(8,205,255,1)', 'rgba(249,74,171,1)', 'rgba(254, 44, 44, 1)', 'rgba(136, 228, 49, 1)', 'rgba(255, 144, 71, 1)', 'rgba(255, 187, 0, 1)', 'rgba(33, 120, 86, 1)', 'rgba(68, 68, 93, 1)', 'rgba(29, 33, 212, 1)', 'rgba(220, 122, 30, 1)']
let colorArr2 = ['rgba(69,125,252,0.2)', 'rgba(189,82,244,0.2)', 'rgba(0,229,166,0.2)', 'rgba(8,205,255,0.2)', 'rgba(249,74,171,0.2)', 'rgba(254, 44, 44, 0.2)', 'rgba(136, 228, 49, 0.2)', 'rgba(255, 144, 71, 0.2)', 'rgba(255, 187, 0, 0.2)', 'rgba(33, 120, 86, 0.2)', 'rgba(68, 68, 93, 0.2)', 'rgba(29, 33, 212, 0.2)', 'rgba(220, 122, 30, 0.2)']
let groupEchartsDataX = ref([])
let groupEchartsData = ref([])
const groupChartLoad = function () {
  var chartDom = document.querySelector('.groupChart');
  var myChart = echarts.init(chartDom);
  var option;

  option = {
    grid: {
      left: 50,
      right: 20,
    },
    color: colorArr,
    legend: {
      show: true,
      type: 'scroll'
    },
    tooltip: {
      trigger: groupChatType.value === 4 ? 'item' : 'axis', // axis   item   none三个值
      show: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: groupChatType.value === 0,
      data: groupEchartsDataX.value,
      show: groupEchartsDataX.value
    },
    yAxis: {
      type: 'value',
    },
    dataZoom: [
      {
        type: 'inside',
        start: 0,
        end: 100,
        disabled: false,
      },
      {
        type: 'slider',
        start: 0,
        end: 100,
        show: groupEchartsDataX.value ? true : false
      }
    ],
    series: groupEchartsData.value
  };
  myChart.clear()
  option && myChart.setOption(option);

  myChart.resize();
  window.onresize = () => {
    myChart.resize();
  }

  // 创建一个ResizeObserver实例
  // const observer = new ResizeObserver(entries => {
  //   myChart.resize();
  // });

// 监听目标div元素的宽度变化
//   let ele = document.querySelector('.contain')
//   observer.observe(ele);
}
// 获取分组图表数据
const getGroupEchartsData = function () {
  if (checkGroup.value && checkGroup.value[0]) {
    openFullScreen()
    getEquipmentDataGroupChartDataApi(qs.stringify({
      id: checkGroup.value[0],
      equipmentId: router.currentRoute.value.query.idStr,
      startTime: groupTime.value[0],
      endTime: groupTime.value[1],
      timeUnit: groupTimeUnit.value,
      chatType: groupChatType.value,
    })).then(async res => {
      loadingAdd.value.close()
      if (res.data.code === 0) {
        groupEchartsDataX.value = res.data.result.xAxis
        groupEchartsData.value = res.data.result.yAxis
        let isThan = false
        for (let i = 0; i < groupEchartsData.value.length; i++) {
          // 把每条数据名称改为设备+指标
          groupEchartsData.value[i].name = groupEchartsData.value[i].deviceName + '-' + groupEchartsData.value[i].titleName
          groupEchartsData.value[i].sampling = 'lttb'
          groupEchartsData.value[i].markPoint = {
            data: [{
              type: 'max',
              name: 'Max',
              symbolSize: 40
            }, {
              type: 'min',
              name: 'Mix',
              symbolSize: 40
            }]
          }
          if (groupEchartsData.value[i].name.includes('同比') || groupEchartsData.value[i].name.includes('环比')) {
            isThan = true
          }

          // 数据处理为小数点两位
          for (let j = 0; j < groupEchartsData.value[i].data.length; j++) {
            groupEchartsData.value[i].data[j] = Number(groupEchartsData.value[i].data[j]).toFixed(2)
          }
        }
        // 图表类型样式
        // 如果是属于折线图
        if (groupChatType.value == 1) {
          for (let i = 0; i < groupEchartsData.value.length; i++) {
            groupEchartsData.value[i].type = 'line'
            groupEchartsData.value[i].color = colorArr[i]
            groupEchartsData.value[i].lineStyle = {
              width: 2,
              shadowColor: colorArr2[i],
              shadowBlur: 4
            }
            groupEchartsData.value[i].symbolSize = 7
          }
        }
        // 如果是柱状图
        if (groupChatType.value == 0) {
          for (let i = 0; i < groupEchartsData.value.length; i++) {
            groupEchartsData.value[i].type = 'bar'
            // 处理同环比的不同样式
            groupEchartsData.value[i].color = colorArr[i]
          }
        }
        await nextTick(() => {
          groupChartLoad()
        })
      } else {
        ElMessage({
          type: 'error',
          message: res.data.message,
        })
      }
    }).catch(err => {
      loadingAdd.value.close()
      console.log(err);
    })
  } else {
    ElMessage({
      type: 'info',
      message: '请先创建分组'
    })
  }
}


// 分享分组操作------------------------------------------------------------
let shareDialogVisible = ref(false)  //分享弹窗
let shareDeviceList = ref([])
// 点击分享
const shareClick = function () {
  shareDialogVisible.value = true
  getShareGroupDeviceApi(qs.stringify({equipmentId: router.currentRoute.value.query.idStr})).then(async res => {
    if (res.data.code === 0) {
      shareDeviceList.value = res.data.result
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message,
      })
    }
  }).catch(err => {
    console.log(err);
  })
}


const deviceVisibleFun = function (data) {
  shareDialogVisible.value = data
}
// 点击提交
const checkDeviceListFun = function (data) {
  let equipmentIdList = []
  for (let i = 0; i < data.length; i++) {
    equipmentIdList.push(data[i].id)
  }
  (router.currentRoute.value.query.isLocal == 2 && router.currentRoute.value.query.type == 1) ? saveLocalShareGroupApi(qs.stringify({
    equipmentIdList: equipmentIdList.join(','),
    equipmentId: router.currentRoute.value.query.idStr,
  })).then(async res => {
    if (res.data.code === 0) {
      shareDialogVisible.value = false
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message,
      })
    }
  }).catch(err => {
    console.log(err);
  }) : saveShareGroupApi(qs.stringify({
    equipmentIdList: equipmentIdList.join(','),
    equipmentId: router.currentRoute.value.query.idStr,
  })).then(async res => {
    if (res.data.code === 0) {
      shareDialogVisible.value = false
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message,
      })
    }
  }).catch(err => {
    console.log(err);
  })
}


// 筛选树形结构唯一值
const onlySelect = function (data) {
  for (let i = 0; i < data.length; i++) {
    if (data[i].type == 1) {
      data[i].id = data[i].id + '_' + data[i].type
    }
    // data[i].onlyValue = data[i].id + '_' + data[i].type
    if (data[i].subList.length > 0) {
      onlySelect(data[i].subList)
    }
  }
}
// 树形结构数据
let allTree = ref()
let intervalList = ref([])  //数据间隔列表
onMounted(async () => {
  // getEquipmentListFun()
  //		await getSearchListFun()
  //			await planChange()
  //			await getEchartsDataFun()
  getListFun()
  getShareGroupListFun()
  // 获取数据间隔列表
  getIntervalListApi().then(async res => {
    if (res.data.code === 0) {
      intervalList.value = res.data.result
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message,
      })
    }
  }).catch(err => {
    console.log(err);
  })
})

</script>

<style lang="less" scoped>
</style>
